import React, {  useState } from 'react'
import { useContext, useEffect } from "react";
import { Navigate, Outlet } from 'react-router-dom'
import NavBar from './componentes/NavBar'
import { Link } from 'react-router-dom';
import { UserContext } from './context/UserProvider';
import Swal from 'sweetalert2'
import { Api } from './componentes/Api';
import 'react-toastify/dist/ReactToastify.css';
import { IdleTimerProvider } from 'react-idle-timer';
import { Card, Col, Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"



const modelo = {
    nombre: "",
    empresaID: "",
    correo: "",
    idRolNavigation: {
        idRol: 0,
        descripcion: ""
    }       
}


let control = 0;

const App = () => {
  
    const { user, cerrarSession } = useContext(UserContext)
    const [impresion, setimpresion] = useState(false);
    const [VerContactos, setVerContactos] = useState(false);
    const [Vers, setVers] = useState(0);
    const [Cro, setCro] = useState(0);
    const [imageSrc, setImageSrc] = useState("");
    const [FechaL, setFechaL] = useState("");
    
    if (user == null) {
        return <Navigate to="/Login" />
    } 



    const Empresa = async () => {
     
        var e = JSON.parse(user).idUsuario;
        let response = await fetch(Api + "Administracion/listaEmpresas/"+e);
        if (response.ok) {
            let data = await response.json()
            //alert(data)
           
            setFechaL(data[0].fechaL)
            //alert(JSON.parse(user).empresaID)

            }
    
    }
    Empresa();

  
  

    const mostrarModalSalir = () => {

        Swal.fire({
            title: 'Esta por salir',
            text: "Desea cerrar sesion?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {
                cerrarSession()
            }
        })

    }
const fetchImage = async () => {
    if (control == 0) { 
            const response = await fetch(Api + "Usuario/MostraFoto/" + JSON.parse(user).idUsuario);
            const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));

    } control = 1
    };


     

        fetchImage();

    //const navigate = Navigate();
    //const sessionId = localStorage.getItem('sessionId'); // Guarda esto después del login

   const handleOnIdle = async () => {
    console.log('Usuario inactivo por 3 minutos');

    //    await fetch.post('/api/session/logout', {
    //        sessionId: sessionId,
    //        bySystem: true
    //    });

    //    localStorage.removeItem('sessionId');
    //    navigate('/login');
 };


    //alert(impresion)
    const hoy = new Date();
    const vencimiento = new Date(FechaL);
    const diferenciaEnMs = vencimiento - hoy;
    const diasRestantes = Math.ceil(diferenciaEnMs / (1000 * 60 * 60 * 24));

    let clase = "alert alert-success";
    let mensaje = `Tu licencia vence el ${vencimiento.toLocaleDateString()} (${diasRestantes} día(s) restantes).`;

    const Vencido1 = () => {
        const diferenciaEnMs = vencimiento - hoy;
        const diasRestantes = Math.ceil(diferenciaEnMs / (1000 * 60 * 60 * 24));
        if (diasRestantes < 0 && Vers == 0) {
            setVerContactos(true)
            setVers(1)

            setTimeout(() => {
                cerrarSession();
               }, 60000);
        }
    }



    if (diasRestantes <= 14 && diasRestantes > 6) {
        clase = "alert alert-warning";
    } else if (diasRestantes <= 6 && diasRestantes > 0) {
        clase = "alert alert-danger";
    } else if (diasRestantes <= 0) {
        clase = "alert alert-danger";
        mensaje = `⚠️ Tu licencia venció el ${vencimiento.toLocaleDateString()}. Contacta soporte para renovarla. En 1 minuto se va a cerrar la sección`;
      
    }
    Vencido1();
  
  


    return (
        <IdleTimerProvider
            timeout={1000 * 60 * 1000} // 3 minutos
            onIdle={handleOnIdle}
        >
        <>
           
            <NavBar data={impresion } />
         
            {/*Content Wrapper*/}
            <div id="content-wrapper" className="d-flex flex-column">

                {/*Main Content*/}
                <div id="content" >
                    <nav  className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                    {/* Sidebar Toggle (Topbar) */}
                    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                        <i className="fa fa-bars"></i>
                        </button>
                            { " . "}  {localStorage.getItem("Empresa") }
                    {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">

                        <div className="topbar-divider d-none d-sm-block"></div>
                     
                        {/* Nav Item - User Information */}
                        <li className="nav-item dropdown no-arrow">
                                   <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                   
                                    <span className="mr-2 d-none d-lg-inline text-gray-600 small">{ JSON.parse(user).correo }</span>
                                    <img className="img-profile rounded-circle"
                                        src={imageSrc} />
                            </a>
                            {/* Dropdown - User Information */}
                            <div  className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                aria-labelledby="userDropdown">
                                <Link className="dropdown-item" to="/">
                                    <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                    Perfil
                                </Link>
                                <div className="dropdown-divider"></div>
                                    <button className="dropdown-item" onClick={mostrarModalSalir}>
                                      <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                      Salir
                                  </button>
                            </div>
                        </li>

                    </ul>

                </nav>
                    <div className="container-fluid">

                        <Outlet />

                    </div>
                </div>
                <footer className="sticky-footer bg-white">
                    <div className="container my-auto">
                        <div className="copyright text-center my-auto">
                            <span>Copyright &copy; APATECH by 3S  2026  v.2.0 </span><img  src="./imagen/logopie.svg" style={{ width:'5%'} } />
                                {(diasRestantes <= 60) && <div className={clase} onClick={() => setVerContactos(true)}>{mensaje}</div>}
                                <button hidden>
                                    <i className="fa fa-user"  >Soporte</i>
                                </button>
                            </div> 
                    </div>
                   

                </footer>
            </div>

                {VerContactos && (
                    <div className="modal d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header bg-warning">
                                    <h4 className="modal-title"><b>⚠️ Información de Licencia</b></h4>
                                    <button type="button" className="btn-close" onClick={() => setVerContactos(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <p><strong>Tu licencia ha vencido o está próxima a vencer.</strong></p>
                                    <p>Para renovarla, puedes comunicarte con nosotros o realizar tu pago por los siguientes medios:</p>
                                    <hr />
                                    <h5><b>📞 Contacto:</b></h5>
                                    <ul>
                                        <li>Telefono: <a href="tel:+18093023936" target="_blank" rel="noreferrer">+1 (809) 302-3936</a></li>
                                        <li>WhatsApp: <a href="https://wa.me/18093023936" target="_blank" rel="noreferrer">+1 (809) 302-3936</a></li>
                                        <li>Email: <a href="mailto:info@apatech.com.do">info@apatech.com.do</a></li>
                                    </ul>
                                    <h5><b>💳 Opciones de pago:</b></h5>
                                    <ul>
                                        <li>Transferencia Bancaria: Banreservas, Banco BHD, Asociacion Popula y Banco Popular</li>
                                        {/*<li>Paypal: paypal.me/apatech</li>*/}
                                    </ul>
                                    <hr />
                                    {(diasRestantes <= 60) && <div className={clase} onClick={() => setVerContactos(true)}>{mensaje}</div>}
                                </div>
                                <div className="modal-footer">
                                    <button  type="button" className="btn btn-secondary" onClick={() => setVerContactos(false)}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>)
                }
            </>
        </IdleTimerProvider>
        )
}

export default App